import { render } from "./BasicLoader.vue?vue&type=template&id=63cb43c9"
import script from "./BasicLoader.vue?vue&type=script&lang=js"
export * from "./BasicLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__